(() => {
  const enhance = (root) => root.querySelectorAll('[data-product-source-tables]').forEach((content) => {
    content.querySelectorAll('table').forEach((table) => {
      if (table.closest('.source-table-scroll') || table.parentElement.closest('table')) return;
      const columns = Math.max(0, ...Array.from(table.rows, (row) => Array.from(row.cells).reduce((sum, cell) => sum + cell.colSpan, 0)));
      table.classList.add(columns <= 2 ? 'source-table--pair' : 'source-table--wide');
      let heading = table.previousElementSibling;
      while (heading && !heading.matches('h2,h3,h4,h5,h6')) heading = heading.previousElementSibling;
      const wrapper = document.createElement('div');
      wrapper.className = 'source-table-scroll';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', table.caption?.textContent.trim() || heading?.textContent.trim() || content.dataset.tableLabel);
      table.before(wrapper);
      wrapper.append(table);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(document), {once:true});
  else enhance(document);
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
